import chroma from 'chroma-js';

export function getLighterShade(color: string): string {
  return chroma(color).desaturate(2).brighten(1).hex();
}

export function getDarkerShade(color: string): string {
  return chroma(color).darken(2).hex();
}
